import React from 'react';
import styled from 'styled-components';
import { FaWindowClose } from 'react-icons/fa';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
background: white;
border-radius: 12px;
width: 90%;
max-width: 1000px;  // 800px에서 1000px로 증가
position: relative;
box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const ModalHeader = styled.div`
  padding: 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ModalTitle = styled.h2`
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #333;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0;
  color: #666;
  display: flex;
  align-items: center;
  
  &:hover {
    color: #333;
  }
`;

const Modal = ({ isOpen, onClose, title, children, shouldCloseOnOverlayClick = true }) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={shouldCloseOnOverlayClick ? onClose : undefined}>
      <ModalContent onClick={e => e.stopPropagation()}>
        <ModalHeader>
          <ModalTitle>{title}</ModalTitle>
          <CloseButton onClick={onClose}>
            <FaWindowClose />
          </CloseButton>
        </ModalHeader>
        {children}
      </ModalContent>
    </ModalOverlay>
  );
};

export default Modal;